shadow$provide[4] = function(require,module,exports) {
"use strict";
exports.__esModule = true;
var react_1 = require("react");
var ThreestrapContext_1 = require("./ThreestrapContext");
var Renderer = function (props) {
    var threestrap = (0, ThreestrapContext_1.useThreestrap)();
    (0, react_1.useEffect)(function () {
        if (props.clearColor) {
            threestrap.renderer.setClearColor(props.clearColor);
        }
    });
    return null;
};
exports["default"] = Renderer;
//# sourceMappingURL=Renderer.js.map
};